import React, { useState } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import Button from "../../../components/atoms/button/button";
import useHomeLinkMode from '../../../hooks/useHomeLinkMode';
import { localStorage } from '../../../utils/storage'
import transversalServices from '../../../services/transversal-services'
import Cookies from 'universal-cookie'
import './cookies-toast.scss'

const CookiesToast = ({ setActiveCookiesToast }) => {

    const { homeLink } = useHomeLinkMode();
    const [loader, setLoader] = useState(false);

    const acceptCookies = () => {
        setLoader(true)
        const tokenInfo = localStorage.getItem('TOKEN_INFO') ? localStorage.getItem('TOKEN_INFO') : null

        let config = {
            headers: {
                Authorization: tokenInfo ? tokenInfo.idToken : "",
            },
        }

        const payload = {
            "accept": true,
            "brandName": "PEQUENIN"
        }

        transversalServices.cookiePolicy(payload, config).then(
            response => {
                setLoader(false)
                if (response.status === 200) {
                    const cookies = new Cookies();
                    let actTime = new Date().getTime();
                    let expire = actTime + (60 * 60 * 24 * 1000 * 365);
                    let expiresIn = new Date(expire)
                    cookies.set('cookiesAccepted', true, { path: '/', expires: expiresIn });
                    closeToast()
                } else if (response.status === 400 && response.errorCode === "DEM000") {
                    const cookies = new Cookies();
                    let actTime = new Date().getTime();
                    let expire = actTime + (60 * 60 * 24 * 1000 * 365);
                    let expiresIn = new Date(expire)
                    cookies.set('cookiesAccepted', true, { path: '/', expires: expiresIn });
                    closeToast()
                } else {
                    setLoader(false)
                    closeToast()
                }
            }
        ).catch(e => console.log(e))
    }

    const closeToast = () => {
        let toast = document.getElementById('f-m-cookies-toast')
        if (toast) {
            toast.classList.add("__hidden")
            setTimeout(function () {
                toast.classList.remove("__hidden")
                setActiveCookiesToast(false)
            }, 200)
        } else {
            setActiveCookiesToast(false)
        }
    }

    return (
        <div className="f-m-cookies-toast" id="f-m-cookies-toast">
            <div className="f-m-cookies-toast__content">
                <StaticImage
                    className="f-m-cookies-toast__logo"
                    src='../../../assets/images/logo-pequenin-desktop.png'
                    alt='logo pequenin cookies'
                    placeholder="blurred"
                />
                <div className="f-m-cookies-toast__info">
                    <div className="f-m-cookies-toast__text">
                        <h3 className="f-m-cookies-toast__title">Este sitio web utiliza cookies</h3>
                        <p className="f-m-cookies-toast__description">Dependemos de las cookies para recordar tus preferencias y analizar el tráfico de nuestro sitio web. Permites nuestras cookies al hacer clic en "Aceptar"</p>
                    </div>
                    <div className="f-m-cookies-toast__buttons">
                        <Button
                            id="f-a-button__f-m-cookies-toast"
                            className="f-a-button__primary-purple f-a-button__medium"
                            copy="Aceptar"
                            loader={loader}
                            onclick={() => acceptCookies()}
                        />
                        <a href={homeLink + "terminos-y-condiciones/"} className="f-m-cookies-toast__terms-link">Ver más</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CookiesToast
